// src/styles/colors.js
export const colors = {
  primary: '#64ffda',
  secondary: 'rgba(245, 245, 245, 0.5)', // 50% d'opacité
  background: 'rgba(10, 31, 68, 0.6)', // 80% d'opacité
  text: '#8892b0',
  accent: 'rgba(222, 29, 141, 0.6)',     // 60% d'opacité
  lightAccent: 'rgba(222, 29, 141, 0.25)' // 25% d'opacité
};